export default {
    handlerMouseWheel: 'controller.bridge.handlerMouseWheel',
    handlerSaveFile: 'controller.bridge.handlerSaveFile',
    handlerSaveUser: 'controller.bridge.handlerSaveUser',
    handlerGetUser: 'controller.bridge.handlerGetUser',
    handlerClose: 'controller.bridge.handlerClose',
    handlerMinimize: 'controller.bridge.handlerMinimize',
    handlerMaximize: 'controller.bridge.handlerMaximize',
    ipcSendMsg: 'controller.bridge.ipcSendMsg',
}